module.exports = __webpack_public_path__ + "img/article_2_1.b17264cc.png";